import React from "react";
import "./TopBanner.css"; 

const TopBanner = () => {
  return (
    <div
      className="w-100 py-2 px-3 px-md-5 hideOnMobile"
      style={{
        background: "black",
        color: "white",
        fontSize: 15 + "px"
      }}
    >
      <span className="roboto-condensed-300">
        Scytáles SDKs libraries available worldwide
      </span>
      <span className="px-4">|</span>
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="whiteLink"
        href="https://www.scytales.com/build-with-scytales-sdks"
      >
        <span className="roboto-condensed-300">
          Start your 30-day free trial now
        </span>
      </a>
      <span className="roboto-condensed-300 float-end">
        W3C DC API / OpenId4Vp 1.0 - DCQL
      </span>
    </div>
  );
};

export default TopBanner;